<template>
  <div
    class="main demo-split"
    id="aa"
    :class="{ mapscreen: $store.state.isMapScreen }"
  >
    <Split v-model="split" min="0" max="400">
      <div slot="left" ref="left" style="height: 100%">
        <monitor-tree
          ref="fleetTree"
          modal="locate"
          deviceUseType="1"
          @selectCarList="reCarList"
          filterGroup="车辆"
        ></monitor-tree>
      </div>
      <div slot="right" ref="right" style="height: 100%">
        <div id="left_right" @click="showHide">
          <Icon v-if="split == 0" type="md-arrow-dropright" />
          <Icon v-else type="md-arrow-dropleft" />
        </div>
        <div id="locateTools">
          <ButtonGroup vertical>
            <Button
              :type="isSearch ? 'primary' : 'default'"
              icon="ios-search"
              title="搜索位置"
              @click="isSearch = !isSearch"
            ></Button>
            <Button
              :type="isAreaFind ? 'primary' : 'default'"
              icon="md-map"
              title="区域查询"
              @click="areaCar"
            ></Button>
            <Button
              :type="isYun ? 'primary' : 'default'"
              icon="md-cloudy"
              title="卫星云图"
              @click="reYun"
            ></Button>
            <Button
              :type="isLukuang ? 'primary' : 'default'"
              icon="md-car"
              title="路况信息"
              @click="reLuKuang"
            ></Button>
            <Button
              :type="isDrawRule ? 'primary' : 'default'"
              icon="ios-paper-plane"
              title="测距"
              @click="reCeju"
            ></Button>
            <Button
              icon="md-pin"
              title="标注点"
              @click="$refs.pointList.open()"
            ></Button>
            <Button
              icon="md-git-merge"
              title="路线规划"
              @click="$refs.lineList.open()"
            ></Button>
            <Button
              icon="ios-disc"
              title="电子围栏"
              @click="$refs.fenceList.open()"
            ></Button
            ><Button
              icon="md-lock"
              title="将正在看的车锁定在地图中心"
              :type="isLock ? 'primary' : 'default'"
              @click="lockCar"
              v-show="false"
            ></Button>
          </ButtonGroup>
        </div>
        <div id="locateSearch" v-if="isSearch">
          <search-add @adds="reAdds"></search-add>
        </div>
        <div id="map-top">
          <g-map
            ref="postDevice"
            @dataWindow="dataWindow = $event"
            @areaCar="$refs.quyuchache.areaCarFunction($event)"
          >
            <icon-window
              ref="infoWindow"
              @video="reVideo"
              :windowData="dataWindow"
              slot="window"
            >
            </icon-window>
          </g-map>
        </div>
        <div id="map-bottom" :style="{ height: height + 'px)' }">
          <locateList
            ref="locateList"
            @status="restatus"
            @tr="$refs.postDevice.showWindow($event, true)"
          ></locateList>
        </div>
      </div>
    </Split>
    <quyuchache ref="quyuchache"></quyuchache>
    <point-list @points="showPoints" ref="pointList"></point-list>
    <line-list @lines="showLineFun" ref="lineList"></line-list>
    <fence-list @fences="showFence" ref="fenceList"></fence-list>
    <div id="video_wrap456" v-if="openVideo">
      <my-video ref="vueVideo" @closeVideo="openVideo = false"></my-video>
    </div>
  </div>
</template>
<script>
import monitorTree from "./locateToolCarPerson.vue";

var m = localStorage.getItem("contact");

import gMap from "../map/locate.vue";
import gMap20 from "../map20/locate.vue";
import locateList from "./locateList.vue";
import iconWindow from "./iconWindow";

import quyuchache from "./quyuchache.vue";
import byVideo from "./com/byVideo.vue";
import lyVideo from "./com/locateVideo.vue";
var vmap = localStorage.getItem('vmap');
export default {
  props: ["isToCenter"],
  components: {
    locateList,
    monitorTree,
    gMap:vmap==2.0?gMap20:gMap,
    iconWindow,
    myVideo: m == "云视频" ? byVideo : lyVideo,
    quyuchache,
  },
  data() {
    return {
      split: "260",
      isSearch: false,
      isDrawRule: false,
      isYun: false,
      isLukuang: false,
      isAreaFind: false,
      isLock: true,
      leftLoteData: [],
      height: 200,
      dataWindow: {},
      openVideo: false,
    };
  },

  methods: {
    areaCar() {
      this.isAreaFind = !this.isAreaFind;
      this.$refs.postDevice.areaCar(this.isAreaFind);
    },

    reYun() {
      this.isYun = !this.isYun;
      this.$refs.postDevice.reYun(this.isYun);
    },
    reLuKuang() {
      this.isLukuang = !this.isLukuang;
      this.$refs.postDevice.reLuKuang(this.isLukuang);
    },
    lockCar() {
      this.isLock = !this.isLock;
      this.$refs.postDevice.lockCar(this.isLock);
    },
    reCeju() {
      this.isDrawRule = !this.isDrawRule;
      this.$refs.postDevice.reCeju(this.isDrawRule);
    },
    reAdds(v) {
      this.$refs.postDevice.reAdds(v);
    },
    showPoints(v) {
      this.$refs.postDevice.showPoints(v);
    },
    showLineFun(v) {
      this.$refs.postDevice.showLineFun(v);
    },
    showFence(v) {
      this.$refs.postDevice.showFence(v);
    },
    //控制子组件播放视频
    reVideo(device) {
      this.openVideo = true;
      setTimeout(() => {
        this.$refs.vueVideo.beforCcreatePlayer(device);
      }, 200);
    },
    showHide() {
      if (this.split == 0) {
        this.split = "260";
        this.$refs.left.style.display = "block";
      } else {
        this.split = 0;
        this.$refs.left.style.display = "none";
      }
    },
    setHight() {},
    reCarList(v, isToCenter) {
      this.$refs.postDevice.websockToLocate(v, isToCenter);
      this.$refs.locateList.websockToLocate(v, isToCenter);
    },
    restatus(v) {
      if (v == 0) {
        this.height = 46;
      } else {
        this.height = 200;
      }
    },
  },
  mounted() {
    //this.setHight();
    if (m == "云视频") {
    } else {
      // this.split = Number(localStorage.getItem("Split1"));
    }
  },

  deactivated() {
    console.log("离开页面了");
  },
};
</script>
<style>
/*去除百度地图版权*/
.anchorBL {
  display: none;
}

.demo-split {
  position: relative;
  border: 1px solid #dcdee2;
}
#left_right {
  position: absolute;
  left: 0;
  top: 48%;
  background: #333;
  width: 18px;
  line-height: 60px;
  z-index: 18;
  color: #fff;
  font-size: 18px;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  opacity: 0.3;
}
#left_right:hover {
  opacity: 0.5;
}
.mapscreen {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6666;
  width: 100%;
  height: 100% !important;
  background: #f5f5f5;
  padding-top: 0 !important;
}
#map-top {
  height: 100%;
}
#map-bottom {
  overflow: hidden;
  position: absolute;
  bottom: 0;
  background: rgb(255, 255, 255);
  width: 100%;
  z-index: 222;
}
#video_wrap456 {
  position: absolute;
  z-index: 110;
  top: 6px;
  right: 6px;
  background: #ccc;
}
#locateTools {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 22;
}
#locateSearch {
  position: absolute;
  top: 10px;
  left: 50px;
  z-index: 22;
}

.alarmNow {
  background: #e60909;
  color: #fff;
  padding: 0 4px;
  margin-right: 2px;
}
#video_wrap {
  position: absolute;
  z-index: 24;
  top: 50px;
  right: 6px;
  background: #ccc;
  width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/carLocate.vue